export default {"src":"/_next/static/media/durables.68d8db9a.svg","height":45,"width":53};